import { FC, ReactElement, ReactNode } from 'react';
import * as St from './HeaderNotification.styles';

export const HeaderNotification: FC<{
  children: ReactNode;
  icon: ReactElement;
  className?: string;
  iconSize?: number;
}> = ({ children, icon, className, iconSize }) => (
  <St.Wrapper className={className} data-cy="header_notification">
    <St.IconContainer $size={iconSize}>{icon}</St.IconContainer>
    <St.Content>{children}</St.Content>
  </St.Wrapper>
);
